import settings from './settings';

const PUB = () => settings.API_PUBLIC_URL ?? '';
const BASE = () => settings.API_BASE_URL ?? '';

export const RPO_SEARCH_URL = 'https://isee.siea.sk/csp/rmee-ext-public/data-lake/rpo';

export const API = {
  login: (recaptcha: string) => `${PUB()}/sec/login?g-recaptcha-response=${recaptcha}`,
  logout: () => `${BASE()}/sec/logout`,
  register: (recaptcha: string) => `${BASE()}-pub/client/register?g-recaptcha-response=${recaptcha}`,
  resetPassword: (recaptcha: string) => `${BASE()}-pub/client/reset-password?g-recaptcha-response=${recaptcha}`,
  actionConsume: (token: string, recaptcha: string) =>
    `${BASE()}-pub/client/action-consume/${token}?g-recaptcha-response=${recaptcha}`,
  appInfo: () => `${PUB()}/discovery/app-info`,
  recordRounds: (recaptcha: string) => `${BASE()}-pub/record/rounds?g-recaptcha-response=${recaptcha}`,
  waitingList: (recaptcha: string) => `${BASE()}-pub/record/order?g-recaptcha-response=${recaptcha}`,
  devicePublic: () => `${BASE()}-pub/cl/GD.CL.Device`,
  rounds: () => `${BASE()}/gd/record/rounds`,
  requestsOverview: () => `${BASE()}/gd/record/overview`,
  sendRequest: (id: string) => `${BASE()}/gd/record/request/${id}/sent`,
  saveRequest: () => `${BASE()}/gd/record/proxy`,
  loadRequest: (id: string) => `${BASE()}/gd/record/proxy/${id}?level_flag=CDL4&inclatt=1`,
  companyData: (companyId: string) => `${BASE()}/gd/entity/company-data/${companyId}`,
  cityCodelist: () => `${BASE()}/gd/cl/city`,
  deviceCodelist: () => `${BASE()}/cl/GD.CL.Device`,
  energeticDeviceTypeCodelist: () => `${BASE()}/cl/GD.CL.Data.EnergeticDeviceType`,
  energeticDeviceSpecificationCodelist: () => `${BASE()}/cl/GD.CL.Data.EnergeticDeviceSpecification`,
  manufacturerCodelist: () => `${BASE()}/cl/GD.CL.Data.Manufacturer`,
  energyEfficiencyClassCodelist: () => `${BASE()}/cl/GD.CL.EnergyEfficiencyClass`,
  refrigerantCodelist: () => `${BASE()}/cl/GD.CL.Refrigerant`,
  energeticDeviceSearch: () => `${BASE()}/gd/record/energetic-device`,
  saveEnergeticDevice: () => `${BASE()}/gd/record/energetic-device`,
  legalFormCodelist: () => `${BASE()}/cl/Entity.CL.LegalForm`,
  companySizeCodelist: () => `${BASE()}/cl/GD.CL.Entity.CompanySize`,
  skNaceCodelist: () => `${BASE()}/cl/GD.CL.Entity.SK.NACE`,
  // BO číselníky (codeLists.js)
  regionTypeCodelist: () => `${BASE()}/cl/GD.CL.Data.RegionType`,
  deviceGroupCodelist: () => `${BASE()}/cl/GD.CL.Data.DeviceGroup`,
  requestStatusCodelist: () => `${BASE()}/cl/GD.CL.Request.Status`,
  addressRegionCodelist: () => `${BASE()}/cl/Entity.CL.Address.Region`,
  calls: () => `${BASE()}/inn/record/calls`,
  regionRestriction: () => `${BASE()}/inn/record/regionrestriction`,
  attachment: () => `${BASE()}/object/attachment`,
  attachmentContent: (id: string) => `${BASE()}/object/attachment/${id}/content`,
  downloadAttachment: (id: string) => `${BASE()}/object/attachment/${id}/redirect`,

  // ─── BackOffice (-int varianty) ───
  requestsOverviewInt: () => `${BASE()}/gd/record/overview-int`,
  loadRequestInt: (id: string) => `${BASE()}/gd/record/proxy-int/${id}?level_flag=CDL4&inclatt=1`,
  loadPrintRequest: (id: string) => `${BASE()}/ipcei/record/proxy/${id}?level_flag=CDL5&inclatt=1`,
  allocationsInt: () => `${BASE()}/gd/record/allocations-int`,
  roundsInt: () => `${BASE()}/gd/record/rounds-int`,
  roundInt: () => `${BASE()}/gd/record/round-int`,
  registrationsInt: () => `${BASE()}/gd/record/registrations-int`,
  registrationInt: (id: string) => `${BASE()}/gd/record/registration-int/${id}`,
  requestStatusInt: (guid: string) => `${BASE()}/gd/record/request-int/${guid}/status`,
  exportData: () => `${BASE()}/object/export`,
  exportFilled: () => `${BASE()}/object/exportfilled`,
  entity: (id: string) => `${BASE()}/entity/entities/${id}?level_flag=CDL3`
};
